const TOKEN_URL = process.env.NODE_ENV === 'production'
  ? 'https://api.ukpetitiontracker.com/api/auth/token'
  : 'http://localhost:3002/api/auth/token';

const TOKEN_TTL_MS = 9 * 60 * 1000; // 9 minutes (server expires at 10)

let cached = null;   // { token, expiresAt }
let inflight = null; // Promise while a fetch is in progress

export async function getToken() {
  const now = Date.now();
  if (cached && cached.expiresAt > now) {
    return cached.token;
  }
  if (inflight) return inflight;

  inflight = (async () => {
    try {
      const res = await window._originalFetch(TOKEN_URL, { method: 'POST' });
      if (!res.ok) throw new Error('Token fetch failed');
      const { token } = await res.json();
      cached = { token, expiresAt: now + TOKEN_TTL_MS };
      return token;
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}
